<template>
  <v-row>
    <LabelCol
      v-if="labelCols"
      :cols="labelCols"
      :attribute="attribute"
    />
    <v-col
      :cols="valueCols"
      class="pa-0"
    >
      <v-text-field
        :value="computedValue"
        readonly
        outlined
        :label="attribute.measure_unit?unitLabel(attribute.measure_unit):null"
      />
    </v-col>
  </v-row>
</template>

<script>
import LabelCol from './LabelCol';

import { DICTS } from '@/dicts';

export default {
  components: {
    LabelCol
  },
  props: {
    attribute: {
      required: true,
      type: Object
    },
    labelCols: {
      default: 4,
      type: Number
    },
    valueCols: {
      default: 8,
      type: Number
    },
    values: {
      required: true,
      type: Object
    },
    value: {
      required: false,
    }
  },
  computed: {
    computedValue() {
      if (this.attribute.subtype === 'sum') {
        let sum = 0;
        let maxDecimalPlaces = 0;
        this.attribute.computed_from.forEach(key => {
          const stringValue = this.values[key].toString();
          const decimalValue = stringValue.split('.')[1];
          if (decimalValue) {
            const decimalValueLength = decimalValue.length;
            maxDecimalPlaces = decimalValueLength > maxDecimalPlaces ? decimalValueLength : maxDecimalPlaces;
          }
          sum += this.values[key] || 0;
        });
        if (!sum) {
          return null;
        }
        return sum.toFixed(maxDecimalPlaces);
      } else if (this.attribute.subtype === 'price') {
        const pumPrice = this.values[this.attribute.computed_from[0]];
        const pum = this.values[this.attribute.computed_from[1]];
        if (!pumPrice || !pumPrice.value || !pum || !pum.value) {
          return null;
        }
        let pumSum = 0;
        Object.values(pum.value).forEach(value => {
          pumSum += value || 0;
        });
        if (!pumSum) {
          return null;
        }
        return (pumPrice.value / pumSum).toFixed(2);
      }
      return undefined;
    }
  },
  methods: {
    unitLabel(unit) {
      return new DOMParser().parseFromString(
        unit.replace('<sup>2</sup>', '&sup2'),
        'text/html'
      ).body.textContent;
    }
  },
  watch: {
    computedValue(nV) {
      this.$emit('input', nV);
    }
  }
};
</script>
